import { connect } from 'react-redux';
import { List } from 'immutable';
import { withRouter } from 'react-router-dom';

import { getSportForEventId, getCountryForEventId, getOtherTagsForEventId } from '@xanadu/ui-shared/modules/event/selectors';
import { enablePIP } from '@xanadu/ui-shared/modules/streaming/actions';

import { getUrlPrefix } from '@xanadu/ui-shared/modules/application/selectors';

import Aside from '../../../components/App/Aside';

const EMPTY_LIST = new List();

const mapDispatchToProps = {
  enablePIP
};

function mapStateToProps(state, ownProps) {
  const { eventId } = ownProps;
  const eventSport = getSportForEventId(state, eventId);
  const eventCountry = getCountryForEventId(state, eventId);
  const eventOtherTags = getOtherTagsForEventId(state, eventId);

  return {
    streamDetails: state.getIn(['streaming', 'stream']),
    streamInfo: state.getIn(['streaming', 'streamInfo']),
    pipEnabled: state.getIn(['streaming', 'pipEnabled']),
    product: state.getIn(['application', 'product']),
    eventSport,
    eventCountry,
    eventOtherTags,
    urlPrefix: getUrlPrefix(state),
    tags: state.getIn(['navigation', 'tags'], EMPTY_LIST),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Aside));
